import { useEffect, useState } from "react";

const SNAPSHOT_MARKER_ID = "prerender-snapshot-marker";

export function isPrerendering() {
  return typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
}

function hasSnapshotMarker() {
  return typeof document !== "undefined" && Boolean(document.getElementById(SNAPSHOT_MARKER_ID));
}

export function useSnapshotRenderMode() {
  const [snapshotMode, setSnapshotMode] = useState(() => isPrerendering() || hasSnapshotMarker());

  useEffect(() => {
    if (!isPrerendering()) {
      setSnapshotMode(false);
    }
  }, []);

  return snapshotMode;
}

export function PrerenderSnapshotMarker() {
  return <span id={SNAPSHOT_MARKER_ID} hidden aria-hidden="true" />;
}
